<template>
  <div class="date-time-picker-time">
    <div class="date-time-picker-time__label">
      <div
        v-if="context.value[index]"
        class="date-time-picker-time__label-time"
      >
        <div>{{ labels.year }}年 <div :style="dotStyle" /></div>
        <div>{{ labels.month }}月</div>
        <div>{{ labels.day }}日</div>
      </div>
      <div
        v-else
        class="date-time-picker-time__label-empty"
      >
        {{ titleProxy }}
      </div>
    </div>
    <div class="date-time-picker-time__time">
      <time-picker
        :disabled="disabled"
        @pick="handlePick"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment-mini'
import TimePicker from '../date-picker/pickers/TimePicker'
moment.locale('zh')
export default {
  name: 'KDateTimePickerTime',
  inject: ['context'],
  provide() {
    return {
      context: this.contextProxy,
    }
  },
  components: {
    TimePicker,
  },
  props: {
    title: {
      type: String,
      default: 'From',
    },
  },
  data() {
    return {
      now: moment(),
      labels: {},
      disabled: false,
      contextProxy: {
        ...this.context,
      },
    }
  },
  computed: {
    index() {
      return this.title === 'From' ? 0 : 1
    },
    dotStyle() {
      return {
        backgroundColor: this.title === 'From' ? '#3D7EFF' : '#00BCA2',
      }
    },
    titleProxy() {
      return this.title === 'From' ? '开始时间' : '结束时间'
    },
  },
  watch: {
    'context.value': {
      deep: true,
      immediate: true,
      handler(val) {
        const value = val && val[this.index]
        if (value) {
          this.labels = {
            day: value.format('DD'),
            month: value.format('MM'),
            year: value.year(),
          }
        }
        this.contextProxy.value = value || moment('2020-12-12 00:00:00') // 初始时间设为0,日期无用，随意取值
                                                                         // 根据title重写provide中的value值
        this.disabled = !(val && val[0] && val[1])
      },
    },
  },
  methods: {
    handlePick(value) {
      this.$emit('time-change', value)
    },
  },
}
</script>

<style lang="scss">
.date-time-picker-time {
  &__label {
    font-size: 16px;
    &-time {
      color: #101030;
      display: flex;
      align-items: center;
      justify-content: center;
      div:nth-child(1) {
        position: relative;
        div{
          height: 6px;
          width: 6px;
          border-radius: 3px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -13px;
        }
      }
      // div:nth-child(2) {
      //   width: 36px;
      //   text-align: right;
      // }
      // div:nth-child(3) {
      //   width: 36px;
      //   text-align: right;
      // }
    }
    &-empty {
      color: #7A7F99;
      text-align: center;
    }
  }
  &__time {
    margin-top: 12px;
    .km-time-picker__pane-wrapper {
      display: flex;
      justify-content: center;
    }
    .km-time-picker__cell {
      max-width: 68px !important;
    }
  }
  .km-input__original{
    font-style: normal;
    text-align: center;
  }
}
</style>
